import {
  CLEAR_UPLOAD_INFORMATION_DATA, CANCEL_ORDER_SELECTION, ORDER_PAGE_UPLOAD_BLUEPRINT_FILE_SUCCESS, UPLOAD_INFORMATION_UPLOAD_BLUEPRINT_FILE_SUCCESS,
} from 'constants/ActionTypes';

export default (state = {}, action = {}) => {
  switch (action.type) {
    case ORDER_PAGE_UPLOAD_BLUEPRINT_FILE_SUCCESS: return { ...state, orderBlueprintFileData: action.fileData };
    case CANCEL_ORDER_SELECTION: return { ...state, orderBlueprintFileData: '' };
    case UPLOAD_INFORMATION_UPLOAD_BLUEPRINT_FILE_SUCCESS: return { ...state, uploadInformationBlueprintFileData: action.fileData };
    case CLEAR_UPLOAD_INFORMATION_DATA: return { ...state, uploadInformationBlueprintFileData: '' };
    default: return state;
  }
};
